import { createFileRoute } from '@tanstack/react-router';
import { RolePermissionModule } from '@/modules/role';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/role/edit/$id')({
  component: RolePermissionModule,
});
